"use client";

import { Obituary } from "@/services/Obituary";
import {
  TObituaryRemoteTribute,
  TObituaryTributeItem,
  TObituaryTributesItem,
  TObituaryTributesList,
} from "@/types/obituary";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import CImage from "../CImage";

import AddTributeModal from "./AddTributeModal";

type Props = {
  slug: string;
};
type TributeProps = {
  info: TObituaryTributesItem;
  value: number;
};

const TributesComponent = ({ slug }: Props) => {
  const [tributesList, setTributesList] = useState<TObituaryRemoteTribute>({});

  const loadTributesList = async () => {
    let tributes: TObituaryRemoteTribute = await Obituary.getObituaryTributes(
      slug
    );
    setTributesList(tributes);
  };

  useEffect(() => {
    loadTributesList();
  }, []);

  const [isValid, setIsValid] = useState<boolean>(false);
  const [tributeList, setTributeList] = useState<
    TObituaryTributeItem[] | undefined
  >(undefined);
  const [showModalForm, setShowModalForm] = useState<boolean>(false);
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const [tributeValue, setTributeValue] = useState<string | undefined>(
    undefined
  );

  const openModal = (active: string | null) => {
    setActiveModal(active);
    setShowModalForm(true);
    if (active === "DOVE") {
      setTributeList(tributesList.DOVE);
      setActiveModal("DOVE");
    } else if (active === "STAR") {
      setTributeList(tributesList.STAR);
      setActiveModal("STAR");
    } else if (active === "FLOWER") {
      setTributeList(tributesList.FLOWER);
      setActiveModal("FLOWER");
    } else if (active === "CANDLE") {
      setTributeList(tributesList.CANDLE);
      setActiveModal("CANDLE");
    } else {
      setTributeList(tributesList.CANDLE);
      setActiveModal("CANDLE");
    }
  };
  const closeModal = () => {
    setShowModalForm(false);
    setActiveModal(null);
  };

  const GetTribute = ({ info, value }: TributeProps) => {
    return (
      <div
        className="relative cursor-pointer"
        data-type={info.name}
        data-value={value}
        id={`tribute-${info.name}`}
        onClick={() => {
          openModal(info.name);
        }}
      >
        <CImage
          src={info.icon}
          width={90}
          height={90}
          alt=""
          className={`relative h-14 w-14 lg:h-20 lg:w-20 ${
            value > 0 ? "" : "opacity-80 mix-blend-luminosity grayscale"
          }`}
        />
        <div className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-3xl bg-primary font-bold text-white">
          {value}
        </div>
      </div>
    );
  };

  return (
    <>
      {showModalForm && (
        <AddTributeModal
          slug={slug}
          closeModal={closeModal}
          loadTributesList={loadTributesList}
          activeModal={activeModal}
          setActiveModal={setActiveModal}
          tributesList={tributesList}
          tributeList={tributeList}
          setTributeList={setTributeList}
        />
      )}
      <div className="flex w-auto flex-row gap-4">
        <GetTribute
          info={TObituaryTributesList.filter((i) => i.name === "FLOWER")[0]}
          value={tributesList.FLOWER ? tributesList.FLOWER.length : 0}
        />
        <GetTribute
          info={TObituaryTributesList.filter((i) => i.name === "CANDLE")[0]}
          value={tributesList.CANDLE ? tributesList.CANDLE.length : 0}
        />
        <GetTribute
          info={TObituaryTributesList.filter((i) => i.name === "DOVE")[0]}
          value={tributesList.DOVE ? tributesList.DOVE.length : 0}
        />
        <GetTribute
          info={TObituaryTributesList.filter((i) => i.name === "STAR")[0]}
          value={tributesList.STAR ? tributesList.STAR.length : 0}
        />
        <div
          className="relative flex h-14 w-14 cursor-pointer items-center justify-center rounded-full bg-primary text-white transition-all duration-300 hover:bg-primary-600 lg:h-20 lg:w-20"
          id="add-tribute-modal"
          onClick={() => {
            openModal(null);
          }}
        >
          <Plus className="h-10 w-10 lg:h-14 lg:w-14" />
        </div>
      </div>
    </>
  );
};

export default TributesComponent;
